import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { getHistory } from '../../api/history'
import { ErrorResponse, responseType } from '../../api/type'
import { HistoryRes } from '../../api/history/response'

const useHistoryList = () => {
  const { data, isLoading, isError, error } = useQuery<responseType<HistoryRes>, AxiosError<ErrorResponse>>({
    queryKey: ['get_history'],
    queryFn: () => getHistory(),
    useErrorBoundary: false,
  })

  return {
    history: data?.data,
    isLoading,
    isError,
    error,
  }
}

export default useHistoryList
